import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

import { assertDevelopmentBuild, DevPreviewUnavailable } from '@/spa/dev-only'

// The ternary is folded by Rollup in a production build, so the preview chunk
// is never emitted. See DevPreviewUnavailable in @/spa/dev-only.
const component = import.meta.env.DEV
  ? lazy(() =>
      import('@/features/services/pages/dev-accounting-preview').then((m) => ({ default: m.AccountingDevPreview })),
    )
  : DevPreviewUnavailable

export const Route = createFileRoute('/_bare/dev/accounting-preview')({
  beforeLoad: assertDevelopmentBuild,
  component,
})
